import * as yup from 'yup';

export const LocationFormSchema = yup.object().shape({
  city: yup.string().required({ tx: 'errors.required' }),
  country: yup.string().required({ tx: 'errors.required' }),
  state: yup.string().required({ tx: 'errors.required' }),
});
